module.exports = __webpack_public_path__ + "img/none.2a925b8a.png";